import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Menu, Content, MenuItem } from '@root/components/Dropdown';
import Icon from '@root/components/Icon';
import { HOUSE_ID, REFRESH_TOKEN, TOKEN } from '@root/constant';
import { isInApp } from '@root/shared';

const MenuSelector = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onNavigate = useCallback(
    (path?: string) => {
      setVisible(false);
      if (path) navigate(path);
    },
    [navigate],
  );

  const onSignOut = useCallback(() => {
    setVisible(false);
    // 退出登录
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(HOUSE_ID);
    window.location.href = `${process.env.REACT_APP_ROUTE_BASE_NAME}/login`;
  }, []);

  const handleOpen = useCallback((value: boolean) => {
    setVisible(value);
  }, []);

  return (
    <Dropdown
      visible={visible}
      align="right"
      // origin="50%"
      onOpen={handleOpen}
      className="menu-dropdown"
    >
      <Menu>
        <Icon type="irMenu" />
      </Menu>
      <Content>
        {/* <MenuItem onClick={() => onNavigate()}>{t('device_services')}</MenuItem> */}
        <MenuItem onClick={() => onNavigate('/bills')}>
          <div className="text-ellipsis">{t('bills_invoices')}</div>
        </MenuItem>
        <MenuItem onClick={() => onNavigate('/billAddress')}>
          <div className="text-ellipsis"> {t('billing_address')}</div>
        </MenuItem>
        {!isInApp && (
          <MenuItem onClick={onSignOut}>
            <div className="text-ellipsis">
              <span className="sign-out">{t('sign_out')}</span>
            </div>
          </MenuItem>
        )}
      </Content>
    </Dropdown>
  );
};

export default MenuSelector;
